import slick from 'slick-carousel';

$('.js-kv-slider').slick({
	// slidesToShow: 1,
	// slidesToScroll: 1,
	arrows: true,
	dots: true,
	autoplay: true,
	autoplaySpeed: 3500,
	variableWidth: false,
	prevArrow: '<div class="l-slickControls__arrow is-prev"></div>',
	nextArrow: '<div class="l-slickControls__arrow is-next"></div>',
	appendArrows: $('.l-slick__controls'),
	appendDots: $('.l-slick__controls'),
	dotsClass: 'l-slickControls__dots',
});



